import { useEffect } from 'react';
export var useKeypress = function (_a) {
    var addEventListenerCondition = _a.addEventListenerCondition, eventListenerDependencies = _a.eventListenerDependencies, handledKeys = _a.handledKeys, keyboardAction = _a.keyboardAction;
    var keyboardHandler = function (e) {
        var keyCode = e.keyCode;
        if (handledKeys.includes(keyCode))
            keyboardAction(e, keyCode);
    };
    useEffect(function () {
        if (addEventListenerCondition) {
            document.addEventListener('keydown', keyboardHandler);
        }
        return function () {
            document.removeEventListener('keydown', keyboardHandler);
        };
    }, [eventListenerDependencies]);
};
